export interface DataTransferSchedulerConfig {
  onSend: () => Promise<void>;
  transferDurationSec?: number;
}
export class DataTransferScheduler {
  timerID?: ReturnType<typeof setTimeout>;
  onSend: () => Promise<void>;
  transferDurationSec: number;

  constructor(config: DataTransferSchedulerConfig) {
    this.onSend = config?.onSend;
    this.transferDurationSec = config?.transferDurationSec || 0.2;
  }

  start() {
    this.clear();
    this.transfer();
  }

  stop() {
    this.clear();
  }

  private clear() {
    if (this.timerID) {
      clearTimeout(this.timerID);
    }
  }

  private transfer() {
    this.timerID = setTimeout(() => {
      this.transfer();
      this.onSend();
    }, this.transferDurationSec * 1000);
  }
}
